import {
  GET_FGMASTER_REQUEST,
  GET_FGMASTER_SUCCESS,
  GET_FGMASTER_FAILURE,
  
  GET_DOWNLOAD_FGMASTER_REQUEST,
  GET_DOWNLOAD_FGMASTER_SUCCESS,
  GET_DOWNLOAD_FGMASTER_FAILURE,
} from "./fgMasterTypes";

const initialState = {
  loading: false,
  fgMaster: [],
  error: "",
};

const getFgMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FGMASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FGMASTER_SUCCESS:
      return {
        loading: false,
        fgMaster: action.payload,
        error: "",
      };
    case GET_FGMASTER_FAILURE:
      return {
        loading: false,
        fgMaster: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDownload = {
  loading: false,
  fgMaster: [],
  error: "",
};

const getDownloadFgMasterReducer = (state = initialStateForDownload, action) => {
  switch (action.type) {
    case GET_DOWNLOAD_FGMASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DOWNLOAD_FGMASTER_SUCCESS:
      return {
        loading: false,
        fgMaster: action.payload,
        error: "",
      };
    case GET_DOWNLOAD_FGMASTER_FAILURE:
      return {
        loading: false,
        fgMaster: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getFgMasterReducer,getDownloadFgMasterReducer};
